const ACCOUNT_ONLY_FILTER_KEYS = new Set([
  "accountStatus",
  "blockReason",
  "blockedBy",
]);

export const ACCOUNT_FILTER_CANDIDATE_SIZE = 2000;

export interface ClientFilterUser {
  id: number | string;
  dateCreated?: string | null;
}

export interface ClientFilterTag {
  tag?: {
    name?: string | null;
  } | null;
}

export interface SplitClientFilters {
  accountFilter: string;
  paymentFilter: string;
  paymentUserIds: string[];
}

export const splitClientFilters = (filter: string): SplitClientFilters => {
  const accountParts: string[] = [];
  const paymentParts: string[] = [];
  const paymentUserIds: string[] = [];

  const normalized = filter.startsWith("&") ? filter.slice(1) : filter;
  normalized
    .split("&")
    .filter(Boolean)
    .forEach((part) => {
      const [key, rawValue = ""] = part.split("=");
      if (ACCOUNT_ONLY_FILTER_KEYS.has(key)) {
        accountParts.push(part);
        return;
      }
      if (key === "userIds") {
        paymentUserIds.push(...rawValue.split(",").filter(Boolean));
        return;
      }
      paymentParts.push(part);
    });

  return {
    accountFilter: accountParts.join("&"),
    paymentFilter: paymentParts.join("&"),
    paymentUserIds,
  };
};

export const stripAccountOnlyClientFilters = (filter: string): string => {
  if (!filter) return "";

  const normalized = filter.startsWith("&") ? filter.slice(1) : filter;
  return normalized
    .split("&")
    .filter(Boolean)
    .filter((part) => {
      const [key] = part.split("=");
      return !ACCOUNT_ONLY_FILTER_KEYS.has(key);
    })
    .join("&");
};

export const isFraudAccountFilter = (filter: string): boolean =>
  /(?:^|&)blockReason=FRAUD_/.test(filter) ||
  /(?:^|&)blockedBy=FRAUD_/.test(filter);

export const excludeProcessedAndSortNewestFirst = <T extends ClientFilterUser>(
  users: T[],
  tagsByLegacyId: Map<string, ClientFilterTag[]>
): T[] =>
  users
    .filter((user) => {
      const tags = tagsByLegacyId.get(String(user.id)) || [];
      return !tags.some((userTag) => {
        const name = userTag.tag?.name;
        return typeof name === "string" && name.toLowerCase() === "processed";
      });
    })
    .sort((a, b) => {
      const aTime = a.dateCreated ? new Date(a.dateCreated).getTime() : 0;
      const bTime = b.dateCreated ? new Date(b.dateCreated).getTime() : 0;
      return bTime - aTime;
    });
